/** @file Drag modifier semantics: snap = setting XOR Ctrl, Shift constrains, Alt duplicates. */

/** Modifier keys held during a drag (a structural subset of `@pose2d/shortcuts` Modifiers). */
export interface DragModifierKeys {
  ctrl: boolean;
  shift: boolean;
  alt: boolean;
}

/** What a drag does with the held keys. */
export interface DragModifiers {
  snap: boolean;
  constrain: boolean;
  duplicate: boolean;
}

/** Resolves the drag behaviour: the grid snap setting is inverted while Ctrl is held (spec 5.10). */
export function dragModifiers(snapSetting: boolean, keys: DragModifierKeys): DragModifiers {
  return { snap: snapSetting !== keys.ctrl, constrain: keys.shift, duplicate: keys.alt };
}
